import {
  STARTING_BACKGROUND_UPLOAD_TASK,
  COMPLETING_BACKGROUND_UPLOAD_TASK,
  CANCELING_BACKGROUND_UPLOAD_TASK,
  UPLOADING_FILE_PROGRESS,
  CREATING_ASSET_SUCCEDDED,
  ADD_ASSET_TO_COLLECTION_SUCCEDDED,
  ADD_ASSET_TO_STREAM_SUCCEDDED,
  ADD_ASSET_TO_GROUP_SUCCEDDED,
  ADD_ASSET_TO_SHARE_SUCCEDDED,
  COLLECTION_ADD_ASSETS,
  ADD_ASSETS_TO_SECTION_SUCCEDDED,
  ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED,
  CONVERSATION_ADD_ASSETS,
  ADD_ASSET_TO_BACKGROUND_TASK,
} from "../actions/actionTypes.jsx";

import { combineReducers } from "redux";

const initialState = {
  tasks: [],
};

function backgroundTaskReducer(state = initialState, action) {
  switch (action.type) {
    case STARTING_BACKGROUND_UPLOAD_TASK:
      var task = action.payload;

      return Object.assign({}, state, {
        ...state,
        tasks: [...state.tasks, task],
      });
    case COMPLETING_BACKGROUND_UPLOAD_TASK:
      var taskID = action.payload;

      var tasks = state.tasks.filter((item) => {
        return item.id != taskID;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });
    case CANCELING_BACKGROUND_UPLOAD_TASK:
      var taskID = action.payload;

      var tasks = state.tasks.filter((item) => {
        return item.id != taskID;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSET_TO_BACKGROUND_TASK: {
      var file = action.payload.file;
      var id = action.payload.id;
      var parent = action.payload.parent;

      var tasks = state.tasks.map((task) => {
        if (task.id === id) {
          var assets = task.assets || [];
          assets = [
            ...assets,
            {
              type: "file",
              file: file,
              progress: 0,
              parent: parent,
            },
          ];

          return {
            ...task,
            assets: assets,
          };
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });
    }

    case UPLOADING_FILE_PROGRESS:
      var file = action.payload.file;
      var progress = action.payload.progress;

      var tasks = state.tasks.map((task) => {
        return Object.assign({}, task, {
          ...task,
          assets:
            task.assets ||
            [].map((item) => {
              if (item && item.type == "file") {
                if (item.file.id == file.id) {
                  return Object.assign({}, item, {
                    ...item,
                    progress: progress,
                  });
                }
              }

              return item;
            }),
        });
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case CREATING_ASSET_SUCCEDDED:
      var file = action.payload.file;

      var tasks = state.tasks.map((task) => {
        return Object.assign({}, task, {
          ...task,
          assets: task.assets.map((item) => {
            if (item && item.type == "file") {
              if (item.file.id == file.id) {
                return {
                  type: "asset",
                  asset: action.payload.asset,
                  synced: false,
                  parent: item.parent,
                };
              }
            }

            return item;
          }),
        });
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSET_TO_COLLECTION_SUCCEDDED:
      var collection = action.payload.collection;

      var tasks = state.tasks.map((task) => {
        if (task.type == "collection" && task.item.id == collection.id) {
          return Object.assign({}, task, {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  collection.assets.find((a) => a.id == item.asset.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          });
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case COLLECTION_ADD_ASSETS:
      var collection = action.payload.id;
      var index = action.payload.section;
      var assets = action.payload.assets;

      var tasks = state.tasks.map((task) => {
        if (task.type == "collection" && task.item.id == collection) {
          return Object.assign({}, task, {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  assets.find((a) => a.id == item.asset.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          });
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case CONVERSATION_ADD_ASSETS:
      var share = action.payload.id;
      var index = action.payload.section;
      var assets = action.payload.assets;

      var tasks = state.tasks.map((task) => {
        if (task.type == "share" && task.item.id == share) {
          return Object.assign({}, task, {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  assets.find((a) => a.id == item.asset.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          });
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });
    case ADD_ASSETS_TO_SECTION_SUCCEDDED:
      var collection = action.payload.collectionId;
      var section = action.payload.section;

      var tasks = state.tasks.map((task) => {
        if (task.type == "collection" && task.item.id == collection) {
          return Object.assign({}, task, {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  section.assets.find((a) => a.id == item.asset.id) != null;

                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          });
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSET_TO_STREAM_SUCCEDDED:
      var stream = action.payload.streamId;
      var asset = action.payload.asset[0];

      var tasks = state.tasks.map((task) => {
        if (task.type == "stream" && task.item.id == stream) {
          return {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced = item.synced || asset.id == item.asset.id;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          };
        }

        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSET_TO_GROUP_SUCCEDDED:
      var group = action.payload.groupId;
      var asset = action.payload.asset[0];

      var tasks = state.tasks.map((task) => {
        return {
          ...task,
          assets: task.assets.map((item) => {
            var parent = item.parent;
            if(!parent){
              parent = task.parent;
            } 

            if (item && item.type == "asset" && parent.id == group) {
              var synced = item.synced || asset.id == item.asset.id;
              return {
                ...item,
                synced: synced,
              };
            }

            return item;
          }),
        };
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSET_TO_SHARE_SUCCEDDED:
      var share = action.payload.share;

      var tasks = state.tasks.map((task) => {
        if (task.type == "share" && task.item.id == share.id) {
          return {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  share.assets.find((a) => a.id == item.asset.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          };
        }
        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });

    case ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED:
      var shareId = action.payload.share;
      var section = action.payload.section;

      var tasks = state.tasks.map((task) => {
        if (task.type == "share" && task.item.id == shareId) {
          return {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  section.assets.find((a) => a.id == item.asset.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          };
        }
        return task;
      });

      return Object.assign({}, state, {
        ...state,
        tasks: tasks,
      });
    default:
      return state;
  }
}

export { backgroundTaskReducer };
